export const UPDATE_INTENT_STATE = 'UPDATE_INTENT_STATE';
export const DELETE_INTENT_STATE = 'DELETE_INTENT_STATE';
export const ALL_INTENTS_LOADING = 'ALL_INTENTS_LOADING';
export const ALL_INTENTS_LOADED = 'ALL_INTENTS_LOADED';
export const ALL_INTENTS_LOAD_ERROR = 'ALL_INTENTS_LOAD_ERROR';
export const INTENT_DATA_LOADING = 'INTENT_DATA_LOADING';
export const INTENT_DATA_LOADED = 'INTENT_DATA_LOADED';
export const INTENT_DATA_ERROR = 'INTENT_DATA_ERROR';
export const NEW_UTTERANCE_ADDED = 'NEW_UTTERANCE_ADDED';
export const UTTERANCE_DELETED = 'UTTERANCE_DELETED';
export const UTTERANCE_UPDATED = 'UTTERANCE_UPDATED';
export const INTENT_UPDATED = 'INTENT_UPDATED';
export const INTENT_DELETED = 'INTENT_DELETED';
export const INTENT_CREATING = 'INTENT_CREATING';
export const INTENT_CREATED = 'INTENT_CREATED';
export const INTENT_CREATION_FAILED = 'INTENT_CREATION_FAILED';
export const CLEAR_ACTIVE_INTENT = 'CLEAR_ACTIVE_INTENT';



// WEBPACK FOOTER //
// ./src/data/redux/intent_details/actiontypes.js